import React from 'react';

import { useDebugActivity_NetSuiteRecordsTabQuery } from 'generated/graphql';



export interface ITableRow {
  id: string;
  name: string;
  internalId: string;
}

export interface IData {
  departments: ITableRow[];
  employees: ITableRow[];
  subsidiaries: ITableRow[];
  shipItems: ITableRow[];
  inventoryItems: ITableRow[];
  paymentMethods: ITableRow[];
  inventoryLocations: ITableRow[];
}

export function useQuery() {
  const tuple = useDebugActivity_NetSuiteRecordsTabQuery({});

  return React.useMemo(
    () => {
      const data: IData = {
        departments: tuple.data?.departments.map(node => ({
          id: node.id,
          internalId: node.internalId,
          name: node.name
        })) ?? [],
        shipItems: tuple.data?.shipItems.nodes.map(node => ({
          id: node.id,
          internalId: node.internalId,
          name: node.name
        })) ?? [],
        subsidiaries: tuple.data?.subsidiaries.map(node => ({
          id: node.id,
          internalId: node.internalId,
          name: node.name
        })) ?? [],
        employees: tuple.data?.employees.map(node => ({
          id: node.id,
          internalId: node.internalId,
          name: node.fullName
        })) ?? [],
        inventoryItems: tuple.data?.items.nodes.map(node => ({
          id: node.id,
          internalId: node.netSuiteInternalId ?? "",
          name: node.sku
        })) ?? [],
        paymentMethods: tuple.data?.netSuitePaymentMethods.map(node => ({
          id: node.id,
          internalId: node.internalId,
          name: node.name
        })) ?? [],
        inventoryLocations: tuple.data?.inventoryLocations.map(node => ({
          id: node.id,
          name: node.name,
          internalId: node.internalId ?? ""
        })) ?? []
      };

      return {
        ...tuple,
        data
      };
    },
    [tuple]
  );
}
